import React, { ChangeEvent, Component, PureComponent } from "react";
import { connect } from "react-redux";
import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Radio,
  createStyles,
  Theme,
  Menu,
  MenuItem,
  Link,
  ClickAwayListener,
  Switch,
  TextField,
} from "@material-ui/core";
import { Error, FormatIndentDecreaseSharp } from "@material-ui/icons";

import { MyPATDialog, MyPATDropdown, MyPATIconButton, MyPATMultiSearch, MyPATTextField } from "../../common";

import { bindActionCreators } from "redux";
import * as XLSX from "xlsx";

import {
  getCourseList,
} from "../../userManagement/actions/userActions";
import contentManagementService from "../service/courseManagementServices";
import * as courseManagementActions from "../actions/courseManagementActions";
import cx from "classnames";
import moment from "moment";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import _, { values } from "lodash";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";
import DropZone from "../../common/DropZone";
import MyPATUploader ,{ Attachment }from "../../common/MyPATUploader";
import {
  getActiveGoals,
} from '../actions/courseManagementActions';
import { handleContentSelect, handleAddContent, deleteDeSelectedData } from '../../course-Management/components/coursePlan/courseListing/helpers/handleAllMyLibraryEvents';
import { AddContent } from "./MyLibrary";
import { preSelectedFilter } from '../../course-Management/components/coursePlan/courseListing/utils/preFilters';
import MyPATUploadPreview,{convertFileOrUrlToPreviewItem} from "../../common/MyPATUploadPreview";
import courseService from "../../mylibrary/services/courseService";
import { setContentFilter } from "./coursePlan/courseListing/helpers/setFilters";
import { mappingWithHash } from "./coursePlan/courseListing/helpers/conceptMapping";
import { BULK_ADD_CONTENT_IMPORT, BULK_ADD_COURSE_IMPORT } from "../Constants/constants";
import goalManagementService from "../../goal-management/services/goalManagementService";
import EditIcon from '@material-ui/icons/Edit';
import { debounce } from "../../../utils";

const styles = (theme: Theme) =>
  createStyles({
    menuItem: {
      borderStyle: "solid",
      borderBottomWidth: 1,
      borderColor: theme.palette.grey[300],
      padding: 0,
      height: "auto",
      minWidth: "170px",
      "&:last-child": {
        borderBottomWidth: 0,
      },
      "& a": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
        width: "100%",
      },
      "& img, & p": {
        display: "inline-block",
        verticalAlign: "middle",
        fontSize: 14,
        lineHeight: "19px",
        color: "#333333",
      },
    },
    bulkTitle: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '10px'
    },
    orDevider: {
      position: "relative",
      marginBottom: 20,
      alignItems: "center",
      // marginTop: 10,
      "&::before": {
        top: "50%",
        left: "47.5%",
        content: '"OR"',
        position: "absolute",
        width: "30px",
        height: "30px",
        backgroundColor: "#F4F8F9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        transform: "translate(0%, -50%)",
        borderRadius: "50%",
        fontWeight: 400,
        fontSize: 12,
        color: "#999",
        fontStyle: 'italic',
      },
      "&::after": {
        left: "50%",
        content: '" "',
        position: "absolute",
        border: "0.5px solid #e4e4e4",
        backgroundColor: '#e4e4e4',
        height: "75%",
      },
      "& button": {
        margin: "10px 0",
      },
    },
    paddingLeft: {
      paddingLeft: 40,
      textAlign: 'center'
    },

    paddingRight: {
      paddingRight: 40,
    },
    disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none",
    },
    optionContainer: {
      marginTop: 10,
      position: "relative",
      "& input": {
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
        borderRadius: 4,
        background: 'none',
        height: 45,
        lineHeight: '45px',
        cursor: 'pointer',
        paddingRight: 70,
        textOverflow: 'ellipsis',
        fontSize: 14,
        // cursor: "pointer",
        '&:focus-visible':{
          outline: '2px solid #1d7dea',
        }
      },      
    },
    optionlistContainer: {
      position: "relative",
      "&:hover": {
        cursor: "pointer",
      },
      "&::after": {
        top: "5px",
        right: "18px",
        border: "solid rgb(0 0 0 / 0%)",
        height: 0,
        content: '" "',
        zIndex: 999,
        position: "absolute",
        transform: "rotate(226deg)",
        boxShadow: "1px 1px 1px #DFDFDF",
        background: "rgb(255 255 255)",
        borderColor: "rgb(194 225 245 / 0%)",
        borderWidth: 9,
        borderBottomColor: "rgb(255 255 255)",
      },
    },
    switchIcon:{
      backgroundColor: '#fff'
    },
    optionList: {
      width: "100%",
      border: "1px solid #DFDFDF",
      display: "block",
      position: "absolute",
      backgroundColor: "#fff",
      top: "13px",
      borderRadius: "7px",
      maxHeight: 250,
      overflowX: "hidden",
      overflowY: "auto",
      zIndex: 2,
      "& input": {
        marginTop: 15,
        paddingLeft: 40,
      },
      "& span": {
        display: "block",
        padding: "1px 0px 2px 10px",
        cursor: "pointer",
      },

      // top: "-16px",
      // right: "15px",
      // width: 0,
      // height: 0,
      // content: '" "',
      // position: "absolute",
      // marginLeft: "-20px",
      // borderLeft: "10px solid transparent",
      // borderRight: "10px solid transparent",
      // borderBottom: "15px solid #dadada",
      // borderTopLeftRadius: "20px",
      // borderTopRightRadius: "0px",
      // }
    },
    optionListEdit: {
      "& span": {
        padding: "10px 15px",
        borderBottom: "1px solid #eee",
      },
    },
    searchContainer: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: '#fff',
      paddingBottom: 15,
      borderBottom: '1px solid #e6e6e6',
      marginBottom: 10,
      paddingLeft: 15,
      paddingRight: 15,
      "& img": {
        left: 29,
        position: "absolute",
        top: 29,
      },
    },
   
    padding2x: {
      padding: "10px 0",
    },
    courseTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#666'
    },
    plusCourse: {
      position: "relative",
      "& span": {
        position: "absolute",
        right: 0,
        top: 8,
        color: "#1d7dea",
        width: 30,
        height: 30,
        backgroundColor: "#e8f2fd",
        borderRadius: "50%",
        fontSize: 13,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        marginRight: 35,
      },
      
    },
    plusCourseEdit:{
      position: 'relative',
      '& span':{
        top: 3,
        color: '#1d7dea',
        width: 40,
        height: 40,
        fontSize: 12,
        position: 'absolute',
        right: 0,
        backgroundColor: '#e8f2fd',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        marginRight: 40,
      }
    },
    fileInfo: {
      fontSize: 12,
      lineHeight: "16px",
      color: "#999",
      display: "block",
      fontWeight: "normal",
    },
    uploadPreview: {
      '&>div:nth-of-type(1)':{
        '&>div:nth-of-type(1)':{
          maxWidth: '100%',
          flexBasis: '100%',
        },
      },
      "&>:first-child": {
        justifyContent: "center",
        "&>:first-child": {
          "&>:first-child": {
            margin: 0,
            padding: '2px 2px',
            '&>div:nth-of-type(1)':{
              alignItems: 'center',
              '&>div:nth-of-type(1)':{
                flexGrow: 0,
                maxWidth: '20%',
                flexBasis: '20%',
                '& img':{
                  width: '18',
                  height: '18',
                },
              },
              '&>div:nth-of-type(2)':{
                flexGrow: 0,
                maxWidth: '80%',
                flexBasis: '80%',
              }
            }
          },
        },
      },
    },
    textCenter: {
      textAlign: "center",
    },
    noBorder: {
      borderBottom: 0,
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      // opacity: 0.5,
      margin: 0,
      width: "2rem",
      height: "2rem",
    },
    buttonCloseCont: {
      position: "relative",
      height: 20,
      "& button": {
        position: "absolute",
        right: "-15px",
        top: "-35px",
        border: "none",
      },
    },
    arrowIcon: {
      position: "absolute",
      right: 16,
      top: 12,
      // transform: "scale(1.3)",
      zIndex: 1,
      width: 20,
      height: 20,
      cursor: 'pointer',
      backgroundColor: "#fff",
      '& img':{
        width: 15,
    },
  },
  editIcon:{
    '& img':{
      marginLeft: 2,
      marginTop: 2,
    }
  },
    dropDownContainer:{
      marginTop: 10,
      '&>div:nth-of-type(1)':{
        '&>div:nth-of-type(1)':{
          '&>div:nth-of-type(1)':{
            height: 45,
            lineHeight: '45px',
          }
        }
      }
    },
     customInput: {
      border: "1px solid #DFDFDF",
      width: "100%",
      padding: "10px",
      borderRadius: 4,
      background: "none",
      height: 45,
      lineHeight: "45px",
      cursor: "pointer",
      maxWidth: 100,
     },
    //  swithMain:{
    //   marginBottom: 10,
    // }, 
    switchBar:{
      height: 22,
      marginTop: '-11px',
      width: 44,
      borderRadius: 20,
      marginLeft: '-17px',
      backgroundColor: '#acacac',
      opacity: 1
    },
     switchContainer:{
       '& label':{
         margin: 0,
       }
     },
     IscheckedSwitch:{
      opacity: 1,
      marginRight: '-17px',      
    },
    checkedSwitch:{
      color: '#fff', 
      marginRight: '-17px',  
      opacity: 1,   
      '& + $switchBar': {
        opacity: 1,
      },
    },
    openLibraryCTA:{
      fontSize: 14,
      fontWeight: 600
    },
    commonFont:{      
        fontSize: 16,
        fontWeight: 600,
        color: '#666'
    },
    mt20:{
      marginTop: 20
    },
    proficiencyInput:{
      width: 100,
      '&>div:nth-of-type(1)':{
        marginBottom: 0,
      }
    },
    primaryBtn:{
      fontSize: 14,
      fontWeight: 600,
      width: 120,
      marginTop: 30,
    },
  });
interface AddBulkContentProps extends WithStyles<typeof styles> {
  classes: any;
  goals: any[];
  courseList: any[];
  setBulkImportTest: Function;
  fetchExistingScheduledTests: Function;
  openAddContent: boolean;
  closeBulkImport: Function;
  redirectToBulkImport: Function;
  getActiveGoals: Function;
  filterSelectedQuestion: any;
  getCourseList:(obj:any)=>void;
}

interface AddBulkContentState {
  isCourseAllSelect: boolean;
  openMyLibrary: boolean;
  openConfirmationPopup: boolean;
  activeGoals: string[];
  selectedSingleCourse:any,
  showCourseDropdown:boolean,
  showItems:number,
  selectedCourse: any[];
  filteredCourseList:any[],
  attachments: Attachment[];
  contentAttachment: Attachment[];
  showSingleGoalDropdown:boolean;
  payload: any;
  contentPayload:any;
  selectedQuestionCount: number;
  tempQuestions: any;
  selectedQuestion: any;
  goalSuggestions:any[],
  contentType:any,
  selectAllCount: number;
  preFilters: any;
  formData:{
    courseType:any;
    contentIds:string[],
    contentLevel:any,
    packageSkus:any,
    isBonus:boolean,
    minProficiency:any
  }
}
const ContentType = [{ label: 'Chapter level', value: 'chapter' }, { label: 'Concept level', value: 'concept' }, ]
const ALLOWED_ORDER_NOTE_ATTACHMENTS = [
  "xls",
  "xlsx",
  "csv",
  "vnd.ms-excel",
  "x-csv",
  "plain",
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "vnd.openxmlformats-officedocument.wordprocessingml.document",
]; 
class AddBulkContent extends PureComponent<
  AddBulkContentProps,
  AddBulkContentState
> {
  upload: any = null;
  contentUpload:any = null;
  constructor(props: AddBulkContentProps) {
    super(props);
    this.state = {
      openMyLibrary: false,
      openConfirmationPopup: false,
      activeGoals: [],
      selectedSingleCourse:{},
      showCourseDropdown:false,
      showItems:0,
      selectedCourse:[],
      filteredCourseList:[],
      isCourseAllSelect: false,
      attachments: [],
      contentAttachment:[],
      showSingleGoalDropdown:false,
      selectedQuestionCount:0,
      tempQuestions: [],
      selectedQuestion: [],
      goalSuggestions:[],
      contentType:'',
      selectAllCount: 0,
      preFilters: preSelectedFilter,
      payload: {
        sourcePackageId: '',
        destinationSkus: [],
        tests: []
      },
      contentPayload:{
          sourcePackageId: '',
          destinationSkus: [],
          tests: []
      },
      formData:{
        courseType:{},
        contentIds:[],
        contentLevel:'',
        packageSkus:[],
        isBonus:false,
        minProficiency:''
      }
    };
  
  this.increaseList = this.increaseList.bind(this);
  this.toggleShowCourseDropdown = debounce(this.toggleShowCourseDropdown, 100);
  this.toggleSingleCourseDropdown = debounce(this.toggleSingleCourseDropdown, 100);
  this.getCourseSuggestions = _.debounce(this.getCourseSuggestions, 200);
  this.handleChange = _.debounce(
    this.handleChange,
    200
  );
    
  }

  componentDidMount() {
   const goalList:any =[];
   const params={
    pageSize:'1000'
   }
    goalManagementService.goalList(params).then((res)=>{
      res.courseTypes.forEach((element:any) => {
        let courseID:any=[];
        const goalModal={
          name:'',
          id:'',
          groupId:'',
          courseTypeId:[],
        }
        goalModal.id=element._id;
        goalModal.name = element.name;
        goalModal.groupId = element.courses[0].groupId
        let list:[] = JSON.parse(JSON.stringify(element.courses));
       
        list &&
        list
          .forEach((data:any) => {
            courseID.push(data.id)
          })
          goalModal.courseTypeId = courseID
        goalList.push(goalModal)
      });
       
        
      
  
     this.setState({
      goalSuggestions:goalList,
      activeGoals:goalList
     })
    })
  }

  componentDidUpdate(prevProps: AddBulkContentProps, prevState: AddBulkContentState) {
    if(this.state.formData.courseType.id != prevState.formData.courseType.id ){
     const goalIds:any ={...this.state.formData}
      this.props.getCourseList({goals:goalIds.courseType.courseTypeId,pagination:false,statusValue:'PUBLISHED,LIVE,PAST',statusType:'master'});
 
    }
  }

    setActiveGoals = (goalData: any[]) => {
      const goalNameArray = goalData.map((goal) => goal.name);
      this.setState({
          activeGoals: goalNameArray,
      });
  };
  
  handleChange = (value: any) => {
    const goalList:any =[];
    if(value.length>=3){
      const params={
        searchQuery:value
      }
    goalManagementService
    .goalList(params)
    .then((res: any) => {
      res.courseTypes.forEach((element:any) => {
        let courseID:any=[];
      
        const goalModal={
          name:'',
          id:'',
          groupId:'',
          courseTypeId:[],
        }
        goalModal.id=element._id;
        goalModal.name = element.name;
        goalModal.groupId = element.courses[0].groupId
        let list:[] = JSON.parse(JSON.stringify(element.courses));
       
        list &&
        list
          .forEach((data:any) => {
            courseID.push(data.id)
          })
          goalModal.courseTypeId = courseID
        goalList.push(goalModal)
      });
     this.setState({
      goalSuggestions:goalList
     })
    })
  }else{
    const activegoal = this.state.activeGoals
   this.setState({
    goalSuggestions:activegoal
   })
  }
  }

  toggleMyLibraryData =()=>{
    const updateformData ={...this.state.formData}
    const prefilters ={...this.state.preFilters}
    prefilters.contentTypeCode ='testpapers,studymaterial';
    prefilters.contentMenu= "all";
    prefilters.ommitSubjectDetails=false;
    if(this.state.formData.contentLevel === 'concept'){
      prefilters.contentSubTypeCode ='concept,note,videos,formulas'
    }else if(this.state.formData.contentLevel === 'chapter'){
      prefilters.contentSubTypeCode ='chap,note,videos,formulas'
    }
    const goalDrillers ={
      course:{
      groupId:'',
        name:'',
        _id:''
      },
      level:'course'
    }
    goalDrillers.course._id = this.state.formData.courseType.groupId;
    goalDrillers.course.groupId =this.state.formData.courseType.groupId;
    goalDrillers.course.name = this.state.formData.courseType.name;
    prefilters.goalsDriller = goalDrillers;
    const contentTypeFilterTestpapers:any={
      disabled:false,
      filterValue:'testpapers',
      filters:[],
      isSelected:true
    }
    const contentTypeFilterChapter:any={
      disabled:false,
      filterValue:'chap',
      filters:[],
      isSelected:true
    }
    const contentTypeFilterConcept:any={
      disabled:false,
      filterValue:'concept',
      filters:[],
      isSelected:true
    }
    const contentTypeFilterStudyMaterial:any={
      disabled:false,
      filterValue:'studymaterial',
      filters:[],
      isSelected:true
    }
    const contentTypeFilterNote:any={
      disabled:false,
      filterValue:'note',
      filters:[],
      isSelected:true
    }
    const contentTypeFilterVideo:any={
      disabled:false,
      filterValue:'videos',
      filters:[],
      isSelected:true
    }
    const contentTypeFilterFormula:any={
      disabled:false,
      filterValue:'formulas',
      filters:[],
      isSelected:true
    }
    prefilters.contentFilterData[0].filters.push(contentTypeFilterTestpapers)
    prefilters.contentFilterData[0].filters.push(contentTypeFilterStudyMaterial)
    if(this.state.formData.contentLevel === 'concept'){
      if(this.state.preFilters.contentFilterData[0].filters[0].filters.length>0){
        prefilters.contentFilterData[0].filters[0].filters =[];
        prefilters.contentFilterData[0].filters[0].filters.push(contentTypeFilterConcept)
      }else{
        prefilters.contentFilterData[0].filters[0].filters.push(contentTypeFilterConcept)
      }
    }else if(this.state.formData.contentLevel === 'chapter'){
      if(this.state.preFilters.contentFilterData[0].filters[0].filters.length>0){
        prefilters.contentFilterData[0].filters[0].filters =[];
        prefilters.contentFilterData[0].filters[0].filters.push(contentTypeFilterChapter)
      }else{
        prefilters.contentFilterData[0].filters[0].filters.push(contentTypeFilterChapter)
      }
      }
    prefilters.contentFilterData[0].filters[1].filters.push(contentTypeFilterNote)
    prefilters.contentFilterData[0].filters[1].filters.push(contentTypeFilterVideo)
    prefilters.contentFilterData[0].filters[1].filters.push(contentTypeFilterFormula)
     //const updatedFormData ={...this.state.formData}
    // updatedFormData.contentIds = this.state.selectedQuestion
    this.setState({
      preFilters:prefilters,
      selectedQuestionCount: this.state.selectedQuestion.length,
     // formData:updatedFormData
    })
    this.setState((prevState: any) => ({
      openMyLibrary: !prevState.openMyLibrary,
      prefilters:prevState.preFilters
    }));
  }
  getGoalSuggestions = () =>{
    return (this.state.activeGoals || []).map((goal: any, i: any) => {
      return {
        id: i,
        label: goal,
        value: goal,
      }
    })
  }
  handleContentSelectFromLibrary = (content: any, totalCount?: number) => {
    const contentLength = totalCount || content.length;
    this.setState({
      selectedQuestion: [...content] || []
    }, () => handleContentSelect(content, contentLength, this.handleSetState));
  };
  handleSetState = (updatedStateValues: any) => {
    this.setState((prevState) => ({
      ...prevState,
      ...updatedStateValues,
    }));
  };
  handleFilterChange =(type: string)=>{
     ContentType.forEach((Type:any) => {
      const updatedFormData ={...this.state.formData}
      if(Type.label === type){
        updatedFormData.contentLevel = Type.value
      this.setState({
        contentType:Type.label,
        formData:updatedFormData
      })
      }
    })
  }
   
  getDropDownItems(){
    return ContentType.map(({ label }) => {
      return label;
    })
  }
  getCourseSuggestions =(value: string)=> {
    const { courseList } = this.props;
    const { selectedSingleCourse } = this.state;

    value = value.toString();

    this.setState((prevState) => {
      let suggestions: any = [];
      if (value.length > 0) {
        value = value.toLowerCase();
        value = value.replace(/[{()}]/g, '');
        value = value.replace(/\\|\//g,'')


        for (let indx = 0; indx < courseList.length; indx++) {
          let ug = courseList[indx];
          if (ug.name && ug.name.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...courseList];
      }
      suggestions = suggestions.filter((ele: any) => ele._id !== selectedSingleCourse.id)
      return { filteredCourseList: suggestions, showItems: 10 };
    });
  }

  handleCourseChange = (event: any) => {
    let subjectID = event.target.value;
    let isChecked = event.target.checked;
    let { isCourseAllSelect, selectedCourse, filteredCourseList } = this.state;
    let newSelectedSubjects = [...selectedCourse];
    let selectedArray = {...this.state.formData}
    if (isChecked) {
    if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
        isCourseAllSelect = true;
        filteredCourseList.forEach((sub:any) => {
          if(!sub.isUpdateLocked){ 
            newSelectedSubjects.push(sub._id);
            selectedArray.packageSkus.push(sub.sku)
          }
        });
      } else {
        filteredCourseList.forEach((sub:any) => {
         if(sub._id == subjectID){
          selectedArray.packageSkus.push(sub.sku)
         }
        });
        newSelectedSubjects.push(subjectID);
        isCourseAllSelect = false;
      }
    } else {
      if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(subjectID);
        newSelectedSubjects.splice(indx, 1);
      }
      isCourseAllSelect = false;
    }
    if(newSelectedSubjects.length === filteredCourseList.length) {
      isCourseAllSelect = true;
    }
    this.setState({ 
      formData:selectedArray,
      selectedCourse: newSelectedSubjects,
       isCourseAllSelect });
   };

  renderer = () => {
    const { courseList } = this.props;
    const { selectedCourse } = this.state;
    if (courseList && courseList.length > 0) {
      let list: any[] = JSON.parse(JSON.stringify(courseList));
      return (
        list &&
        list
          .reduce((acc: string[], { _id, name }) => {
            if (selectedCourse.includes(_id)) {
              acc.push(name);
            }
            return acc;
          }, []).splice(0, 1)
          .join(", ")
      );
    } else {
      return [];
    }
  };
  rendererMyLibraryData = () => {
   const { selectedQuestion } = this.state;
    if (selectedQuestion && selectedQuestion.length > 0) {
      const contentIds:any =[];
      let contents = JSON.parse(JSON.stringify(selectedQuestion));
      contents.forEach((element:any) => {
        contentIds.push(element.contentId)
      });
     return contentIds.splice(0,3)
    } else {
      return [];
    }
    
  };

  increaseList =() => {
    this.setState((prevState) => ({
      ...prevState,
      showItems: ((prevState.showItems + 10) > this.props.courseList.length) ?  this.props.courseList.length : prevState.showItems + 10
    }));

  }
   toggleShowCourseDropdown =()=> {
     const {showCourseDropdown} = this.state;
     let list = this.props.courseList.filter( (ele: any) => ele._id !== this.state.selectedSingleCourse.id);
     this.setState({ showCourseDropdown: !showCourseDropdown, filteredCourseList: [...list], showItems: 10});
  }

      setAttachments = (attachments: Attachment[]) => {
        this.setState({
          attachments,
        });
        if(attachments.length > 0) {
          this.handleFile(attachments);
    
        } else {
          const updtaedFormData ={...this.state.formData}
          updtaedFormData.packageSkus = []
           this.setState({
            formData:updtaedFormData
          })
          this.setState((prevState) => ({
            ...prevState,
            payload: { ...prevState.payload, destinationSkus: [] },
          }));
        }
      };
      setAttachmentsContent = (attachments: Attachment[]) => {
        this.setState({
          contentAttachment:attachments,
        });
        if(attachments.length > 0) {
          this.handleContentFile(attachments);
    
        } else {
          const updtaedFormData ={...this.state.formData}
          updtaedFormData.contentIds = []
           this.setState({
            formData:updtaedFormData
          })
          this.setState((prevState) => ({
            ...prevState,
            contentPayload: { ...prevState.contentPayload, destinationSkus: [] },
          }));
        }
      };

      handleContentFile=(Files: Attachment[]) => {
        this.readContentExcel(Files[0]);
      }
      handleFile = (Files: Attachment[]) => {
        this.readExcel(Files[0]);
      };
      readContentExcel = (file: any) => {
        let contentID: any[];
        const promise = new Promise((resolve: any, reject: any) => {
          const fileReader = new FileReader();
          if(file.type !== "text/csv") { 
            fileReader.readAsArrayBuffer(file);
    
          } else {
            fileReader.readAsText(file);
    
          }
    
          fileReader.onload = (e: any) => {
            const bufferArray = e.target.result;
    
            const wb = XLSX.read(bufferArray, { type: "buffer" });
    
            const wsname = wb.SheetNames[0];
    
            const ws = wb.Sheets[wsname];
    
            const data = XLSX.utils.sheet_to_json(ws);
    
            resolve(data); 
    
            fileReader.onerror = (error) => {
              reject(error);
            };
    
          };
        });
        promise.then((d: any) => {
          contentID = d && d.map( (sku: any) => sku.ContentId);
          const updtaedFormData ={...this.state.formData}
          updtaedFormData.contentIds = contentID
           this.setState({
            formData:updtaedFormData
          })
          this.setState((prevState) => ({
            ...prevState,
            contentPayload: { ...prevState.contentPayload, contentID },
          }));
    
         });
      } 
      readExcel = (file: any) => {
        let destinationSkus: any[];
        const promise = new Promise((resolve: any, reject: any) => {
          const fileReader = new FileReader();
          if(file.type !== "text/csv") { 
            fileReader.readAsArrayBuffer(file);
    
          } else {
            fileReader.readAsText(file);
    
          }
    
          fileReader.onload = (e: any) => {
            const bufferArray = e.target.result;
    
            const wb = XLSX.read(bufferArray, { type: "buffer" });
    
            const wsname = wb.SheetNames[0];
    
            const ws = wb.Sheets[wsname];
    
            const data = XLSX.utils.sheet_to_json(ws);
    
            resolve(data); 
    
            fileReader.onerror = (error) => {
              reject(error);
            };
    
          };
        });
    
        promise.then((d: any) => {
          destinationSkus = d && d.map( (sku: any) => sku.SKU);
          const updtaedFormData ={...this.state.formData}
          updtaedFormData.packageSkus = destinationSkus
          this.setState({
            formData:updtaedFormData
          })
          this.setState((prevState) => ({
            ...prevState,
            payload: { ...prevState.payload, destinationSkus },
          }));
    
         });
      }

      toggleSingleCourseDropdown=()=> {
        const { showSingleGoalDropdown } = this.state;
        this.setState({
          showSingleGoalDropdown: !showSingleGoalDropdown,
        });
      }

        handleSingleGoalChange = (
          id: string,
          name: string,
          groupId:any,
          courseTypeId:any
        ) => {
          let newSelectedSubjects = { id, name,groupId,courseTypeId };
          const updatedForm = {...this.state.formData}
          updatedForm.courseType = newSelectedSubjects
         this.setState({
            formData:updatedForm,
             selectedSingleCourse: newSelectedSubjects,
             showSingleGoalDropdown: false
          });
        }

      handleInitialState = () => {
        const { filterSelectedQuestion = [] } = this.props;
        this.setState({
          tempQuestions: [],
          selectedQuestionCount: this.state.formData.contentIds.length,
          //selectedQuestion: []
        })
      }

      bulkAddProcess = async () => {
        const updtaedFormData ={...this.state.formData}
        if(updtaedFormData.minProficiency){
          parseInt(updtaedFormData.minProficiency)
        }else{
          updtaedFormData.minProficiency =0
        }
        
       await  contentManagementService.addBlukContent(updtaedFormData)
        this.props.closeBulkImport();
        this.props.redirectToBulkImport();
      }

      openConfirmationDialog=()=>{
        // let testCourseCount =await courseManagementService.fetchCourseDataListWithScheduleId(payload);
        // testCourseCount = testCourseCount.count;
        this.setState({ openConfirmationPopup: true,
          //testCourseCount, scheduleIds 
        });
      }
    
      closeConfirmationDialog() {
        this.setState({ openConfirmationPopup: false });
      }

      changeBonus=()=>{
        const updatedFormData = {...this.state.formData};
        updatedFormData.isBonus = !this.state.formData.isBonus
        if(updatedFormData.isBonus == false){
          updatedFormData.minProficiency =''
        }
        this.setState({
          formData:updatedFormData
        })
      }
      handleProficency=(data:any)=>{
       const updatedFormData = {...this.state.formData};
        updatedFormData.minProficiency = data
        this.setState({
          formData:updatedFormData
        })
      
      }

      onlyAllowNumbers = (evt: any, { allowNegative, currentValue } = { allowNegative: false, currentValue: '' }) => {
        var theEvent = evt
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        if(allowNegative) {
            if(key === '-' && !currentValue) {
                return;
            }
        }

        var regex = /[0-9]|\./;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    }

      handleAddContentFromLibrary = () => {
       const { selectedQuestion, } = this.state;
       const contentIds:any =[];
        let contents = JSON.parse(JSON.stringify(selectedQuestion));
        contents.forEach((element:any) => {
          contentIds.push(element.contentId)
        });
        const updatedFormData = {...this.state.formData};
        updatedFormData.contentIds = contentIds
        this.setState({
          formData:updatedFormData,
          selectedQuestionCount: updatedFormData.contentIds.length,
        })
        this.handleSetState({
          tempQuestions: [],
          selectedQuestionCount: updatedFormData.contentIds.length,
        });
      }
      
      handleContentSelectAll = (selectedQuestion: any, totalCount?: number) => {
        this.handleContentSelectFromLibrary(selectedQuestion, totalCount)
      }

      getAllSelectCount = (count: number) => {
        this.setState({
         selectAllCount: count
        });
       }

       updateContentTypeValue = (e: any) => {
        let selectedContentType = e;
        this.setState({ contentType:selectedContentType })
      }

      handleDownloadClick=()=>{
        const url: string = BULK_ADD_CONTENT_IMPORT;
        window.open(url, "_blank");
      }

      handleSampleDownloadClick=()=>{
        const url: string = BULK_ADD_COURSE_IMPORT;
        window.open(url, "_blank");
      }

      checkDestinationPayload =()=>{
        let value:boolean=false;
         if(this.state.payload.destinationSkus){
          if(this.state.payload.destinationSkus.length>0){
            this.state.payload.destinationSkus.forEach((element:any) => {
              if(element === undefined){
                value = true
              }else{
                value= false
              }
            }); 
          }
        }
        else{
          value = true
        }
      return value
      }
      checkPayload=()=>{
        let value:boolean=false;
        if(this.state.formData.contentIds.length>0){
          this.state.formData.contentIds.forEach((element:any) => {
            if(element === undefined){
              value= true
            }else{
              value= false
            }
          }); 
        }
      
     
    return value
    }
      disableAdd=()=>{
        if(this.state.formData.contentIds.length <= 0 || this.state.formData.packageSkus.length <= 0 || this.state.formData.courseType == '' ||
        this.state.formData.contentLevel == '' || (this.state.formData.isBonus && this.state.formData.minProficiency<1) || this.checkPayload() || this.checkDestinationPayload()){
          return true
        }else {
          return false
        }

      }
      ctadisable=()=>{
        if(!_.isEmpty(this.state.contentAttachment)){
          return true
        }
        return false
      }
     
  render() {
    const { classes,openAddContent,courseList,goals } = this.props;
    const { openMyLibrary,selectedSingleCourse,showCourseDropdown,selectedCourse,filteredCourseList,isCourseAllSelect,attachments,showSingleGoalDropdown,activeGoals,
    selectedQuestionCount,selectedQuestion,goalSuggestions,contentAttachment,openConfirmationPopup,contentType,preFilters } = this.state
    return (
      <>
        <MyPATDialog
          dialogOpen={openAddContent}
          dialogHasActions={true}
          dialogHeading={
            <>
              <h3 className={classes.bulkTitle}> Bulk Add Content</h3>
            </>
          }
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.props.closeBulkImport}
          isCustomBackground={false}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: 'sm',
          }}
          className='dialogBox'
          isborderDialogAction={true}
          customDialogActions={
            <>
              <Grid container justify="center">
                <Grid item>
                  <Button  variant="contained"
                  className={classes.primaryBtn}
                    color="primary"
                    disabled={this.disableAdd()}
                    
                    onClick={() => {
                      this.openConfirmationDialog();
                    }}>
                    Add
                  </Button>
                </Grid>
              </Grid>
            </>
          }
        >
          <Grid container spacing={16} className={classes.padding2x}>
            <Grid item xs={6} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>
                Select a Goal
              </Typography>
              <div className={classes.optionContainer}>
                <div
                  onClick={this.toggleSingleCourseDropdown}
                >
                  <input
                    type="text"
                    placeholder="Select A Course"
                    value={selectedSingleCourse.name}
                  />
                  <Grid className={classes.arrowIcon}>
                  {/* <KeyboardArrowDownIcon /> */}
                  <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>
                {showSingleGoalDropdown && (
                <ClickAwayListener onClickAway={this.toggleSingleCourseDropdown}>

                  <div className={classes.optionlistContainer}>
                    <div className={[classes.optionList, classes.optionListEdit].join(' ')}>
                      <div className={classes.searchContainer}>
                        <input
                          type="text"
                          placeholder="Select a Goal"
                          onChange={(event) => {
                            this.handleChange(event.target.value);
                          }}
                        />
                        <img src="/assets/svg/userManagement/search-icon.svg" />
                      </div>
                      {(goalSuggestions || []).map(
                        ({ id, name,groupId,courseTypeId}) => (
                          <span
                            key={id}
                            onClick={() =>
                              this.handleSingleGoalChange(
                                id,
                                name,
                                groupId,
                                courseTypeId
                              )
                            }
                          >
                            {name}
                          </span>
                        )
                      )}
                    </div>
                    </div>
                    </ClickAwayListener>
                  )}
                </div>
            </Grid>

            <Grid item xs={6} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>
                Add Content At
              </Typography>
              <Grid className={classes.dropDownContainer}>
                <MyPATDropdown
                  placeholder="Select Location"
                  dropdownItems={this.getDropDownItems()}
                  selectedItem={contentType} 
                  onChange={this.handleFilterChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={16} alignItems="center">
            <Grid item xs={6}>
              <Grid style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Grid >
                  <Typography style={{fontSize: 13,fontWeight: 600}}
                  className={cx(
                    (!this.state.formData.isBonus)  ? classes.disabled : ""
                    )}>Mark content as Bonus Content?&nbsp;</Typography>
                </Grid>
                <Grid className={classes.switchContainer}>
                <FormControlLabel
                control={
                  <Switch
                  classes={{
                    root: classes.swithMain,
                    icon: classes.switchIcon,
                    bar: classes.switchBar,
                    iconChecked: classes.IscheckedSwitch,
                    checked: classes.checkedSwitch,
                  }}
                    checked={this.state.formData.isBonus}
                    onChange={this.changeBonus}
                    value="checkedB"
                    color="primary"
                  />
                }
                label=""
              />
                </Grid>
              </Grid>



            </Grid>
            <Grid item xs={6}>
              <Grid style={{display: 'grid', gridTemplateColumns: '60% 40%', alignItems: 'center'}}>
              <Grid >
                  <Typography className={cx(
                    (!this.state.formData.isBonus) ? classes.disabled : "", classes.commonFont
                    )}>Minimum Proficiency</Typography>
                </Grid>

                <Grid className={classes.proficiencyInput}>
                <MyPATTextField
                   name="value"
                   placeholder="Value (%)"
                   type={'number'}                   
                   disabled={!this.state.formData.isBonus}
                   onChange={(e: ChangeEvent<HTMLInputElement>) =>{
                    let value: string | number = e.target.value;
                    if (value) {
                      value = parseInt(value) > 0 ? parseInt(value) : 1;
                      value =
                        value > 100 ? this.state.formData.minProficiency : value;
                    }
                    this.handleProficency(value)
                    }}
                   onKeyPress={(e: any) =>
                    this.onlyAllowNumbers(e)
                   }
                   value={this.state.formData.minProficiency}
                   endAdornment={<></>}
               />
             </Grid>
              </Grid>

              </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.orDevider}>
            <Grid item xs={6} style={{paddingRight: '30px'}}>
              <Typography variant="h4" className={classes.courseTitle}>
                Select Content
              </Typography>
              {
                selectedQuestion.length == 0 &&(
                <Button
                variant="outlined"
                color="primary"
                className={classes.openLibraryCTA}
                onClick={this.toggleMyLibraryData}
                disabled={this.ctadisable()}
                >
                Open My Library
              </Button>
                )
              }
              
              {Boolean(Object.keys(preFilters).length) && openMyLibrary && (
                <AddContent
                  openMyLibary={openMyLibrary}
                  selectedContentType={contentType}
                  type="studyMaterial"
                  selectedQuestionCount={selectedQuestionCount}
                  selectedQuestion={selectedQuestion}
                  handleBackToComponent={this.toggleMyLibraryData}
                  handleContentSelect={this.handleContentSelectFromLibrary}
                  handleInitialState={this.handleInitialState}
                  isSelectAllRequired={true}
                  preSelectedFilterContent={preFilters}
                  handleAddContent={this.handleAddContentFromLibrary}
                  isCourse={true}
                  handleContentSelectAll={this.handleContentSelectAll}
                  getAllSelectCount={this.getAllSelectCount}
                  updateContentTypeValueParent={this.updateContentTypeValue}
                />
              )}
              {
                selectedQuestion.length>0 &&(
                  <>
                <div className={classes.optionContainer}>
                <div
                  className={cx(classes.plusCourseEdit,
                    (contentAttachment.length > 0)  ? classes.disabled : ""
                    )}
                    onClick={this.toggleMyLibraryData}
                >
                  <input
                    type="text"
                    placeholder="Add Content"
                    value={this.rendererMyLibraryData()}
                    disabled={true}
                  />
                  {selectedQuestion.length > 3 && (
                    <span>+{selectedQuestion.length-3}</span>
                  )}
                  <Grid className={[classes.arrowIcon, classes.editIcon].join(' ')}
                  onClick={this.toggleMyLibraryData}>
                    {/* <KeyboardArrowDownIcon /> */}
                    {/* <EditIcon /> */}
                    <img
                    alt="Download"
                    src="/assets/svg/edit-icon-1x.svg"
                    onClick={this.toggleMyLibraryData}
                  />
                  </Grid>
                </div>
              </div>
         
                  </>
                )
               }
              
            </Grid>

            <Grid item xs={6} className={cx(
                classes.paddingLeft,
                selectedQuestion.length > 0 ? classes.disabled : ""
              )}>
              <Typography className={[classes.commonFont, classes.mt20].join(' ')}>Upload the list of Content</Typography>
              <MyPATUploader
                  onChange={this.setAttachmentsContent}
                  allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                  initialAttachments={contentAttachment}
                >
                  {({
                    onItemRemove,
                    attachments,
                    loading,
                    errorMsg,
                    error,
                    handleFileChange,
                  }) => {
                    const list = attachments.map((attachment) =>
                      convertFileOrUrlToPreviewItem(attachment)
                    );
                    return (
                      <>
                          {attachments.length > 0 ? (
                          <Grid className={classes.uploadPreview}>
                            <MyPATUploadPreview
                              list={list}
                              readOnly={false}
                              onItemRemove={onItemRemove}
                            />
                          {error && (
                            <Grid item xs={12} justify="center">
                              <Typography
                                className={classes.errorText}
                                variant="caption"
                                color="error"
                              >
                                <Error />
                                {errorMsg}
                              </Typography>
                            </Grid>
                             )}
                             </Grid>
                      ) : (
                         <DropZone onChange={handleFileChange}>
                         <Grid container justify="center">
                           <div className={classes.dragDropVideoContainer}>
                             <Grid container justify="center">
                               <div style={{ width: "100%" }}>
                                 <Button
                                  variant="outlined"
                                  color="primary"
                                  className={classes.openLibraryCTA}
                                   //alt="Cancel video upload"
                                  // src="/assets/svg/learn/cloudUpload.svg"
                                   onClick={(e) => {
                                     this.contentUpload.value = "";
                                     this.contentUpload.click();
                                   }}
                                  // style={{ cursor: "pointer" }}
                                 >
                                   Upload File
                                   </Button>
                               </div>
                               {/* <Typography
                                 className={classes.dragDropVideoText}
                                 component="div"
                                 variant="body1"
                                 align="center"
                               >
                                 {false
                                   ? "uploading"
                                   : "Upload a file"}
                               </Typography> */}
                               <input
                                 id="myInput"
                                 type="file"
                                 ref={(ref) => (this.contentUpload = ref)}
                                 onChange={(event: any) => {
                                   handleFileChange(event);
                                 }}
                                 style={{ display: "none" }}
                               />
                              </Grid>
                            </div>
                          </Grid>
                        </DropZone>
                      )}
                    </>
                  );
                }}
              </MyPATUploader>
              {
                this.checkPayload() &&
                <>
                <span style={{color:'red'}}>Invalid Sheet</span>
                </>
                
              }
              <Typography color="primary">
                <a  onClick={this.handleDownloadClick} style={{ cursor: "pointer" }}>
                  <img
                    alt="Download"
                    src="/assets/svg/learn/downloadIcon.svg"
                  />{" "}
                  Download Sample Format
                </a>
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.orDevider}>
            <Grid
              item
              xs={6}
              className={classes.paddingRight}
              style={{ paddingRight: 30 }}
            >
              <Typography variant="h4" className={classes.courseTitle}>
                Select Destination Course(s)
              </Typography>
              <div className={classes.optionContainer}>
                <div
                  className={cx(classes.plusCourseEdit,
                    (attachments.length > 0)  ? classes.disabled : ""
                    )}
                  onClick={this.toggleShowCourseDropdown}
                >
                  <input
                    type="text"
                    placeholder="Select Destination Course(s)"
                    value={this.renderer()}
                  />
                  {selectedCourse.length > 1 && (
                    <span>+{selectedCourse.length - 1}</span>
                  )}
                  <Grid className={classes.arrowIcon}>
                    {/* <KeyboardArrowDownIcon /> */}
                    <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>

                {showCourseDropdown && (
                  <ClickAwayListener
                    onClickAway={this.toggleShowCourseDropdown}
                  >
                    <div className={classes.optionlistContainer}>
                      <div
                        className={classes.optionList}
                        onScroll={(e: any) => this.increaseList()}
                      >
                        <div className={classes.searchContainer}>
                          <input
                            type="text"
                            placeholder="Search Destination Course"
                            onChange={(event) => {
                              this.getCourseSuggestions(event.target.value);
                            }}
                          />
                          <img src="/assets/svg/userManagement/search-icon.svg" />
                        </div>
                        {filteredCourseList.length > 0 && (
                          <span>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    isCourseAllSelect &&
                                    filteredCourseList.length ==
                                      selectedCourse.length
                                  }
                                  onChange={this.handleCourseChange}
                                  name="Select All"
                                  color="primary"
                                />
                              }
                              label="Select All"
                              value="SelectAll"
                              key="select_all_course"
                            />
                          </span>
                        )}
                        {(filteredCourseList || [])
                          .slice(0, this.state.showItems)
                          .map(({ _id, name,isUpdateLocked }) => (
                            <span>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedCourse.includes(_id)}
                                    onChange={this.handleCourseChange}
                                    name="checkedB"
                                    color="primary"
                                    disabled={isUpdateLocked}
                                  />
                                }
                                label={name}
                                key={_id}
                                value={_id}
                              />
                            </span>
                          ))}
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </Grid>
            <Grid item xs={6} className={cx(
                classes.paddingLeft,
                selectedCourse.length > 0 ? classes.disabled : ""
              )}>
              <Typography className={[classes.commonFont, classes.mt20].join(' ')}>Upload the list of Courses</Typography>
              <MyPATUploader
                onChange={this.setAttachments}
                allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                initialAttachments={attachments}
              >
                {({
                  onItemRemove,
                  attachments,
                  loading,
                  errorMsg,
                  error,
                  handleFileChange,
                }) => {
                  const list = attachments.map((attachment) =>
                    convertFileOrUrlToPreviewItem(attachment)
                  );
                  return (
                    <>
                      {attachments.length > 0 ? (
                        <Grid className={classes.uploadPreview}>
                          <MyPATUploadPreview
                            list={list}
                            readOnly={false}
                            onItemRemove={onItemRemove}
                          />

                          {error && (
                            <Grid item xs={12} justify="center">
                              <Typography
                                className={classes.errorText}
                                variant="caption"
                                color="error"
                              >
                                <Error />
                                {errorMsg}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      ) : (
                        <DropZone onChange={handleFileChange}>
                          <Grid container justify="center">
                            <div className={classes.dragDropVideoContainer}>
                              <Grid container justify="center">
                                <div style={{ width: "100%" }}>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.openLibraryCTA}
                                    // alt="Cancel video upload"
                                    // src="/assets/svg/learn/cloudUpload.svg"
                                    onClick={(e) => {
                                      this.upload.value = "";
                                      this.upload.click();
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    Upload File
                                    </Button>
                                </div>
                                {/* <Typography
                                  className={classes.dragDropVideoText}
                                  component="div"
                                  variant="body1"
                                  align="center"
                                >
                                  {false ? "uploading" : "Upload a file"}
                                </Typography> */}
                                <input
                                  id="myInput"
                                  type="file"
                                  ref={(ref) => (this.upload = ref)}
                                  onChange={(event: any) => {
                                    handleFileChange(event);
                                  }}
                                  style={{ display: "none" }}
                                />
                              </Grid>
                            </div>
                          </Grid>
                        </DropZone>
                      )}
                    </>
                  );
                }}
              </MyPATUploader>
              {
                this.checkDestinationPayload() &&
                <>
                <span style={{color:'red'}}>Invalid Sheet</span>
                </>
                
              }
              <Typography color="primary">
                <a onClick={this.handleSampleDownloadClick} style={{ cursor: "pointer" }}>
                  <img
                    alt="Download"
                    src="/assets/svg/learn/downloadIcon.svg"
                  />{" "}
                  Download Sample Format
                </a>
              </Typography>
            </Grid>
          </Grid>
        </MyPATDialog>
        <MyPATDialog
          dialogOpen={openConfirmationPopup}
          dialogHasActions={true}
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={() => this.closeConfirmationDialog()}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="center"
                style={{ paddingBottom: "30px" }}
              >
                <Grid item>
                  <Button
                    color="primary"
                      onClick={() => this.closeConfirmationDialog()}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.bulkAddProcess()}
                  >
                    Yes
                  </Button>
                </Grid>
              </Grid>
              <br />
            </>
          }
        >
          <Grid className={classes.buttonCloseCont}>
            <MyPATIconButton
              className={classes.buttonClose}
              buttonVariant="flat"
              onClick={() => this.closeConfirmationDialog()}
            >
              <CloseIcon classes={{ root: classes.iconRoot }} />
            </MyPATIconButton>
          </Grid>
          <Grid container justify="center" style={{ textAlign: "center" }}>
            <Grid item>
              <img src="/assets/svg/Import-scheduled-icon.svg" />
              <h3>Bulk Add Content</h3>
              <Typography>
                Are you sure, you want to add {this.state.formData.contentIds.length} content items in {this.state.formData.packageSkus.length}  courses?
              </Typography>
            </Grid>
          </Grid>
        </MyPATDialog>
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  courseList: state.clientManagement.usersManagement.courseList,
  
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    { 
      getActiveGoals: getActiveGoals,
      fetchExistingScheduledTests:
        courseManagementActions.fetchExistingScheduledTests,
        getCourseList
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(AddBulkContent));
